var _g, _defs;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#466a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.245 1H4.5v2.5H1.169l1.22-2.018A1 1 0 0 1 3.246 1M1 4.5v4.912C1 10.289 1.711 11 2.588 11h6.824C10.289 11 11 10.289 11 9.412V4.5H7.5v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1zm4.5 0v1h1v-1zm2-1h3.331l-1.22-2.018A1 1 0 0 0 8.754 1H7.5zm-1 0h-1V1h1zm5.5.558a2 2 0 0 0-.289-1.035L10.466.965A2 2 0 0 0 8.755 0h-5.51a2 2 0 0 0-1.711.965L.289 3.023A2 2 0 0 0 0 4.058v5.354A2.59 2.59 0 0 0 2.588 12h6.824A2.59 2.59 0 0 0 12 9.412zM2.5 8a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "466a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
});
const SvgBoxsmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBoxsmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzI3MV8xNjAzKSI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMy4yNDUxNSAxSDQuNVYzLjVIMS4xNjg3OUwyLjM4OTU2IDEuNDgyMzRDMi41NzA3MiAxLjE4MjkzIDIuODk1MiAxIDMuMjQ1MTUgMVpNMSA0LjVWOS40MTE3N0MxIDEwLjI4ODkgMS43MTEwOCAxMSAyLjU4ODI0IDExSDkuNDExNzdDMTAuMjg4OSAxMSAxMSAxMC4yODg5IDExIDkuNDExNzdWNC41SDcuNVY1LjVDNy41IDYuMDUyMjggNy4wNTIyOSA2LjUgNi41IDYuNUg1LjVDNC45NDc3MiA2LjUgNC41IDYuMDUyMjkgNC41IDUuNVY0LjVIMVpNNS41IDQuNVY1LjVINi41VjQuNUg1LjVaTTcuNSAzLjVIMTAuODMxMkw5LjYxMDQ0IDEuNDgyMzRDOS40MjkyOCAxLjE4MjkzIDkuMTA0OCAxIDguNzU0ODUgMUg3LjVWMy41Wk02LjUgMy41SDUuNVYxSDYuNVYzLjVaTTEyIDQuMDU3OTVDMTIgMy42OTI5NiAxMS45MDAxIDMuMzM0OTEgMTEuNzExMiAzLjAyMjYzTDEwLjQ2NiAwLjk2NDY3NEMxMC4xMDM3IDAuMzY1ODYgOS40NTQ3NCAyLjE0NTc3ZS0wNiA4Ljc1NDg1IDIuMTQ1NzdlLTA2SDcuMDAxNDhMNyAwSDVMNC45OTg1MiAyLjE0NTc3ZS0wNkgzLjI0NTE1QzIuNTQ1MjYgMi4xNDU3N2UtMDYgMS44OTYyOSAwLjM2NTg2IDEuNTMzOTggMC45NjQ2NzRMMC4yODg4MzIgMy4wMjI2M0MwLjA5OTg4NDkgMy4zMzQ5MSAwIDMuNjkyOTYgMCA0LjA1Nzk1VjkuNDExNzdDMCAxMC44NDEyIDEuMTU4NzkgMTIgMi41ODgyNCAxMkg5LjQxMTc3QzEwLjg0MTIgMTIgMTIgMTAuODQxMiAxMiA5LjQxMTc3VjQuMDU3OTVaTTIuNSA3Ljk5OTk5QzIuMjIzODYgNy45OTk5OSAyIDguMjIzODUgMiA4LjQ5OTk5QzIgOC43NzYxMyAyLjIyMzg2IDguOTk5OTkgMi41IDguOTk5OTlINS41QzUuNzc2MTQgOC45OTk5OSA2IDguNzc2MTMgNiA4LjQ5OTk5QzYgOC4yMjM4NSA1Ljc3NjE0IDcuOTk5OTkgNS41IDcuOTk5OTlIMi41WiIgZmlsbD0iY3VycmVudENvbG9yIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMjcxXzE2MDMiPgo8cmVjdCB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";